import { render, staticRenderFns } from "./MediaActionCopyLink.vue?vue&type=template&id=7b4d3bfc&"
import script from "./MediaActionCopyLink.vue?vue&type=script&lang=ts&"
export * from "./MediaActionCopyLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports